<template>
  <div class="sino-card" v-loading.fullscreen.lock="loading">
    <!-- 头部开始 -->
    <topPart :rightPart="true">
      <template slot="difinePort">
        <!-- 制度按钮盒子 -->
        <div class="btn-block">
          <div class="rule-box" @click="enterRule">
            <img class="hospital-icon" src="../../../assets/images/hospital_icon.png" />
            <span class="hospital-rule">制度</span>
          </div>
          <!-- 制度按钮盒子结束 -->
          <!-- 申请按钮盒子 -->
          <div @click="enterPage" v-if="displayOrNot" class="apply-box">
            <van-icon
              name="plus"
              color="#29BEBC"
              style="vertical-align: middle;font-size:17px;margin-right: 1px;"
            />
            <span class="hospital-apply-btn">申请</span>
          </div>
        </div>
        <!-- 申请按钮盒子结束 -->
      </template>
    </topPart>
    <!-- 头部结束 -->

    <div class="list-block" v-infinite-scroll="loadMore" infinite-scroll-distance="50">
      <div
        class="card-box"
        @click="detailsOfSympathy(item)"
        v-for="item in condoleList"
        :key="item.id"
      >
        <!-- 名称列表 -->
        <div class="name-title-box">
          <span class="nameTitleStyle">{{getNameTitle(item)}}</span>
          &nbsp;
          <span class="departmentStyle">{{getDepartment(item)}}</span>
        </div>
        <!-- 名称列表结束 -->

        <!-- 内容列表 -->
        <div class="rowBox" v-for="(objConfig,index) in arrCondfig" :key="index">
          <span class="rowBoxTitle">{{objConfig.title}}</span>
          <div class="type-img-box">
            <span class="rowBoxConter">{{strategy(objConfig,item)}}</span>
          </div>
        </div>
        <div class="startStyleBox">
          <div :class="'startStyle ' + start[item.state].style">{{start[item.state].showTitle}}</div>
        </div>
        <div class="imgStyleBox" v-if="checkAgrn(item)">
          <img class="imgStyle" v-if="item.state == 1" src="@/images/adopt.png" />
          <img class="imgStyle" v-else src="@/images/noAdopt.png" />
        </div>
        <!-- 内容列表结束 -->
      </div>

      <p class="nomore" v-if="noMore">没有更多了</p>

      <div v-if="condoleList.length == 0" class="blank">
        <img src="@/images/404-02.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { getComfortList } from "@/common/api";
import { toast } from "@/common/api/api.js";
import topPart from "../../../components/topPart";
export default {
  components: {
    topPart,
  },
  data() {
    return {
      arrCondfig: [
        {
          key: "",
          title: "申请类型",
          fun: "type",
        },
        {
          key: "sex",
          title: "性别",
          fun: "sexTrofm",
        },
        {
          key: "age",
          title: "年龄",
          fun: "ordinary",
        },
        {
          key: "money",
          title: "申请补助金额",
          fun: "ordinary",
        },
        {
          key: "reason",
          title: "申请补助原因",
          fun: "ordinary",
        },
        {
          key: "applyDateStr",
          title: "申请日期",
          fun: "ordinary",
        },
      ],
      start: {},
      comfortType: "",
      titleName: "",
      condoleList: [],
      loading: true,
      currentPage: 0,
      pageSize: 10,
      noMore: false,
      displayOrNot: false,
      loginInfo: "",
    };
  },
  created() {
    this.getConfigObj();
    this.displayOrNotFun();
  },
  mounted() {
    this.loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    //this.getCondoleList();
  },
  methods: {
    //制度事件
    enterRule() {
      this.$router.push({
        path: "/hospitalizationRule",
        query: {
          backEndObj: JSON.stringify({ flag: this.comfortType }), //慰问类型,
          backEndInterface: "getArrovalInfo", //后端接口
        },
      });
    },
    //性别转换函数
    sexTrofm(item, obj) {
      if (obj[item.key] == "1") {
        return "男";
      }
      if (obj[item.key] == "2") {
        return "女";
      }
      return "无效数据!";
    },
    //转换按钮展示
    buttonTransfrom(data) {
      if (data.difficultyStart != "1") {
        //快关处于关闭状态
        return false;
      }
      var start = data.difficultyPointSrart; //获取开始时间
      start = new Date(start).getTime(); //转成时间戳
      var end = data.difficultyPointEnd; //获取结束时间
      end = new Date(end).getTime(); //转成时间戳
      var now = new Date().getTime(); //现在时间戳
      if (start > now || end < now) {
        //不在时间段内
        return false;
      }
      return true;
    },
    //申请按钮是否展示
    displayOrNotFun() {
      var obj = {
        flag: "4",
      };
      this.centralControl.axios.centralControl(
        "getAcquisitionSystem",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            this.displayOrNot = this.buttonTransfrom(data);
          }
        },
        obj
      );
    },
    //制度事件
    system() {
      console.log("制度事件触发");
    },
    detailsOfSympathy(obj) {
      this.$router.push({
        path: "/detailsOfSympathy",
        query: {
          flagRouter: true, //是否审批标识
          row: obj.orderNumber, //慰问类型,
          comfortType: obj.comfortType,
        },
      });
    },
    //返回单子名称
    type() {
      return "困难补助申请";
    },
    //普通函数
    ordinary(item, obj) {
      return obj[item.key];
    },
    //获取标示位
    getConfigObj() {
      //获取配置对象
      var conObj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      this.start = this.centralControl.utils.getConfig(conObj, ["start"]);

      var configObj = this.centralControl.utils.getConfig(conObj, ["subsidy"]);
      //获取类型标识
      this.comfortType = configObj.type;
      //添加title名称
      this.titleName = configObj.title;
    },
    //根据对象的key获取对象的值
    getObjAsKey(obj, key) {
      return obj[key];
    },
    checkAgrn(obj) {
      if ("1,2,3".indexOf(obj.state + "") != -1) {
        return true;
      } else {
        return false;
      }
    },
    //获取名称标识
    getNameTitle(item) {
      return this.getObjAsKey(item, "name");
    },
    //策略函数
    strategy(item, obj) {
      return this[item.fun](item, obj);
    },
    //获取科室
    getDepartment(item) {
      var dept_name = this.getObjAsKey(item, "dept_name"); //科室
      var union_name = this.getObjAsKey(item, "union_name"); //分会
      var str = union_name;
      if (dept_name) {
        str = str + "-" + dept_name;
      }
      return str;
    },
    getCondoleList() {
      var obj = {
        comfortType: this.comfortType,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        unionId:this.loginInfo.unionId
      };
      this.centralControl.axios.centralControl(
        "selectSympathy",
        (res) => { 
          if (res.code == 200) {
            this.loading = false;
            this.condoleList = [...this.condoleList, ...res.data];
            if (this.condoleList.length > 0 && res.data.length == 0) {
              this.noMore = true;
              return;
            }
          } else {
            toast(this, res.message, "error");
            this.loading = false;
          }
        },
        obj
      );
    },
    enterPage() {
      this.$router.push("/subsidyApply");
    },
    loadMore() {
      this.currentPage = this.currentPage + 1;
      this.getCondoleList();
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';

.rowBoxConter {
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-gray;
}

.type-img-box {
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 10px;
}

.rowBox {
  padding: 0 15px;
  line-height: 32px;
  display: flex;
}

.rowBoxTitle {
  width: 25%;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.hospital-icon {
  width: 17px;
}

.hos-reason {
  width: 100% !important;
  display: flex;
  line-height: 20px;
}

.apply-box {
  width: 80px;
  text-align: right;
}

.name-title-box {
  padding: 15px 10px 12px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 8px;
}

.hospital-apply-btn {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: $default-color;
}

.hospital-rule {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
}

.imgStyleBox {
  width: 30%;
  position: absolute;
  top: 15%;
  right: 15%;
}

.imgStyle {
  width: 100%;
}

.imgBoxStype {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 30%;
  height: 25px;
}

.height {
  color: #38c7c4;
}

.noheight {
  color: red;
}

.imgStype {
  width: 100%;
}

.nameTitleStyle {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
}

.departmentStyle {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
}

.startStyleBox {
  display: flex;
  justify-content: flex-end;
  padding: 3px 10px 7px;
  border-top: 1px solid #EFEFF4;
  margin-top: 10px;
}

.startStyle {
  text-align: center;
  padding: 5px;
}

.tab-list {
  display: flex;
  flex: 6;

  .title {
    span {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.hospital-icon {
  width: 17px;
}

.hospital-rule {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
}

.nomore {
  font-size: 12px;
  padding-bottom: 10px;
  text-align: center;
  color: #808080;
}

.sino-card {
  position: relative;

  .sion-card-title {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .btn-block {
    margin: auto 10px;
    flex: 2;
    display: flex;
    justify-content: flex-end;

    .btn {
      border: none;
      background: rgba(56, 199, 196, 1);
      border-radius: 8px;
      color: #fff;
      font-size: 14px;
      width: 55px;
      height: 28px;
    }
  }

  .list-block {
    overflow: scroll;
    margin-top: 50px;

    .card-box {
      position: relative;
      padding: 0;
      border-bottom: 1px solid #F4F4F7;
      margin-bottom: 10px;

      .row {
        flex-direction: row;
        justify-content: flex-start;
        display: flex;
        padding: 0 10px 2px;

        p {
          width: 50%;
          padding: 5px 0;

          .title {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(53, 53, 53, 1);
          }

          .content {
            flex: 1;
            padding-left: 15px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
          }
        }

        p.reason {
          width: 100%;
          display: flex;

          .content {
            font-size: 14px;
            color: rgba(136, 136, 136, 1);
            line-height: 18px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .nodata {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>